/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { common } from '@qwyk/models';
import { NotificationsEntity } from '../models/notifications';

export const init = createAction('[Portals/Notifications] Init');

export const loadNotifications = createAction(
    '[Portals/Notifications] Load Notifications'
);

export const loadNotificationsSuccess = createAction(
    '[Portals/Notifications] Load Notifications Success',
    props<{ notifications: common.PaginatedResponse<NotificationsEntity> }>()
);

export const loadNotificationsFailure = createAction(
    '[Portals/Notifications] Load Notifications Failure',
    props<{ error: any }>()
);

export const loadMoreNotifications = createAction(
    '[Portals/Notifications] Load More Notifications'
);

export const markNotificationAsRead = createAction(
    '[Portals/Notifications] Mark Notification As Read',
    props<{ notification: NotificationsEntity }>()
);

export const markNotificationAsReadSuccess = createAction(
    '[Portals/Notifications] Mark Notification As Read Success',
    props<{ notification: Update<NotificationsEntity> }>()
);

export const markNotificationAsReadFailure = createAction(
    '[Portals/Notifications] Mark Notification As Read Failure',
    props<{ error: any }>()
);

export const markAllNotificationsAsRead = createAction(
    '[Portals/Notifications] Mark All Notifications As Read'
);

export const markAllNotificationsAsReadSuccess = createAction(
    '[Portals/Notifications] Mark All Notifications As Read Success',
    props<{ notifications: Update<NotificationsEntity>[] }>()
);

export const markAllNotificationsAsReadFailure = createAction(
    '[Portals/Notifications] Mark All Notifications As Read Failure',
    props<{ error: any }>()
);

export const deleteNotification = createAction(
    '[Portals/Notifications] Delete Notification',
    props<{ notification: NotificationsEntity }>()
);
export const deleteNotificationSuccess = createAction(
    '[Portals/Notifications] Delete Notification Success',
    props<{ unread: number }>()
);
export const deleteNotificationFailure = createAction(
    '[Portals/Notifications] Delete Notification Failure',
    props<{ error: any; restore: NotificationsEntity }>()
);

export const toggleNotificationRead = createAction(
    '[Portals/Notifications] Toggle Read',
    props<{ notification: Update<NotificationsEntity> }>()
);
export const toggleNotificationReadSuccess = createAction(
    '[Portals/Notifications] Toggle Read Success',
    props<{ unread: number }>()
);
export const toggleNotificationReadFailure = createAction(
    '[Portals/Notifications] Toggle Read Failure',
    props<{ error: any; restore: Update<NotificationsEntity> }>()
);

export const selectNotification = createAction(
    '[Portals/Notifications] Select Notification',
    props<{ notification: NotificationsEntity }>()
);
export const unselectNotification = createAction(
    '[Portals/Notifications] Unselect Notification'
);

export const loadUnreadNotifications = createAction(
    '[Portals/Notifications] Load Unread Notifications'
);
export const loadUnreadNotificationsSuccess = createAction(
    '[Portals/Notifications] Load Unread Notifications Success',
    props<{ unread: number }>()
);
export const loadUnreadNotificationsFailure = createAction(
    '[Portals/Notifications] Load Unread Notifications Failure',
    props<{ error: any }>()
);

// Echo
export const initializeEchoListener = createAction(
    '[Portals/Notifications] Initialize Echo Listener',
    props<{ token: string; userId: string }>()
);

export const deinitializeEchoListener = createAction(
    '[Portals/Notifications] Deinitialize Echo Listener'
);

export const echoNotificationReceived = createAction(
    '[Portals/Notifications] Echo Notification Received',
    props<{ notification: NotificationsEntity }>()
);
